import '@fancyapps/fancybox/dist/jquery.fancybox.js';

// Fancybox Options
$.fancybox.defaults.hash = false;
$.fancybox.defaults.infobar = false;
//$.fancybox.defaults.toolbar = false;
$.fancybox.defaults.wheel = false;
$.fancybox.defaults.buttons = [
    //"zoom",
    //"share",
    //"slideShow",
    //"fullScreen",
    //"download",
    //"thumbs",
    "close"
];